export default "__VITE_ASSET__5GATv5Md__"